import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { storage, authFB } from '../../../helpers/Firebase';
import { servicePath, storagePath } from '../../../constants/defaultValues';
import { NotificationManager } from '../../../components/common/react-notifications';
import moment from 'moment';
import { 
  EVALUATION_MESSAGE_LIST,
  EVALUATION_MESSAGE_SEARCH_ASSESSMENT,
  EVALUATION_MESSAGE_SEARCH_EVALUATION_DETAIL,
  EVALUATION_MESSAGE_ADD,
  EVALUATION_MESSAGE_DETAIL,
  EVALUATION_MESSAGE_UPDATE,
  EVALUATION_MESSAGE_UPLOAD_SET
} from '../../actions';
import {
  EvaluationMessageListSuccess,
  EvaluationMessageListError,
  EvaluationMessageSearchAssessmentSuccess,
  EvaluationMessageSearchAssessmentError,
  EvaluationMessageSearchEvaluationDetailSuccess,
  EvaluationMessageSearchEvaluationDetailError,
  EvaluationMessageAddSuccess,
  EvaluationMessageAddError,
  EvaluationMessageDetailSuccess,
  EvaluationMessageDetailError,
  EvaluationMessageUpdateSuccess,
  EvaluationMessageUpdateError,
  EvaluationMessageUploadSetSuccess,
  EvaluationMessageUploadSetError
} from '../../actions';
 
export function* watchEvaluationMessageList() {
  yield takeEvery(EVALUATION_MESSAGE_LIST, onEvaluationMessageList);
}

export function* watchEvaluationMessageSearchAssessment() {
  yield takeEvery(EVALUATION_MESSAGE_SEARCH_ASSESSMENT, onEvaluationMessageSearchAssessment);
}

export function* watchEvaluationMessageSearchEvaluationDetail() {
  yield takeEvery(EVALUATION_MESSAGE_SEARCH_EVALUATION_DETAIL, onEvaluationMessageSearchEvaluationDetail);
}

export function* watchEvaluationMessageAdd() {
  yield takeEvery(EVALUATION_MESSAGE_ADD, onEvaluationMessageAdd);
}

export function* watchEvaluationMessageDetail() {
  yield takeEvery(EVALUATION_MESSAGE_DETAIL, onEvaluationMessageDetail);
}

export function* watchEvaluationMessageUpdate() {
  yield takeEvery(EVALUATION_MESSAGE_UPDATE, onEvaluationMessageUpdate);
}

export function* watchEvaluationMessageUpload() {
  yield takeEvery(EVALUATION_MESSAGE_UPLOAD_SET, onEvaluationMessageUpload);
}

const onEvaluationMessageListAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/evaluation_message/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onEvaluationMessageUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/evaluation_message/update', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const onEvaluationMessageSearchAssessmentAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/assessment/assessment', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onEvaluationMessageSearchEvaluationDetailAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/assessment/evaluation_detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onEvaluationMessageAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/evaluation_message/add', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data.payload)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

const onEvaluationMessageDetailAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/evaluation_message/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onEvaluationMessageUploadAsync = async (file) => {
  var user = await authFB.currentUser;
  var storageRef = storage.ref()
  let now = moment();
  let filename = `${now.format("x")}.${file.name.substr(file.name.lastIndexOf('.') + 1)}`;
  return await new Promise((success, reject) => {
    var uploadTask = storageRef.child(storagePath+'/evaluation_message/' + filename).put(file);
    uploadTask.on('state_changed',
    function(snapshot) {
      var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      console.log('Upload is ' + progress + '% done');
    }, 
    function(error) {
      reject({ name: filename, original: file.name, message: error.code, url: '',  type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path: user.uid+'/consult_documents/' })
    }, 
    function() {
      uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) { 
          success({ message: 'success', name: filename, original: file.name, url: downloadURL, type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path: user.uid +'/consult_documents/'});
      });
    });
  });
};


function* onEvaluationMessageList(data) {
  try {
    const response = yield call(onEvaluationMessageListAsync, data.payload);
    yield put(EvaluationMessageListSuccess(response.data));
  } catch (error) {
    yield put(EvaluationMessageListError(error));
  }
}

function* onEvaluationMessageSearchAssessment(data) {
  try {
    const response = yield call(onEvaluationMessageSearchAssessmentAsync, data.payload);
    yield put(EvaluationMessageSearchAssessmentSuccess(response.data));
  } catch (error) {
    yield put(EvaluationMessageSearchAssessmentError(error));
  }
}

function* onEvaluationMessageSearchEvaluationDetail(data) {
  try {
    const response = yield call(onEvaluationMessageSearchEvaluationDetailAsync, data.payload);
    yield put(EvaluationMessageSearchEvaluationDetailSuccess(response.data));
  } catch (error) {
    yield put(EvaluationMessageSearchEvaluationDetailError(error));
  }
}
function* onEvaluationMessageAdd(data) {
  try {
      const response = yield call(onEvaluationMessageAddAsync, data);
      console.log(response)
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(EvaluationMessageAddSuccess(response.data));
  } catch (error) {
      yield put(EvaluationMessageAddError(error));
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
  }
}

function* onEvaluationMessageDetail(data) {
  try {
    const response = yield call(onEvaluationMessageDetailAsync, data.payload);
    yield put(EvaluationMessageDetailSuccess(response.data.data));
  } catch (error) {
    yield put(EvaluationMessageDetailError(error));
  }
}

function* onEvaluationMessageUpdate(data) {
  try {
      const response = yield call(onEvaluationMessageUpdateAsync, data.payload);
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(EvaluationMessageUpdateSuccess(response.data));
  } catch (error) {
      yield put(EvaluationMessageUpdateError(error));
  }
}

function* onEvaluationMessageUpload({ payload }) {
  const { file } = payload;
  try {
    const response = yield call(onEvaluationMessageUploadAsync, file);
    if(response.message ==='success'){
      yield put(EvaluationMessageUploadSetSuccess(response));
    }
    else{
      yield put(EvaluationMessageUploadSetError(response));
    }
  } catch (error) {
    yield put(EvaluationMessageUploadSetError({ name: '', original: file.name, message: error, url: '',  type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path:''}))
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchEvaluationMessageList),
    fork(watchEvaluationMessageSearchAssessment),
    fork(watchEvaluationMessageSearchEvaluationDetail),
    fork(watchEvaluationMessageAdd),
    fork(watchEvaluationMessageDetail),
    fork(watchEvaluationMessageUpdate),
    fork(watchEvaluationMessageUpload),
  ]);
} 